import { render } from "./InfoTooltip.vue?vue&type=template&id=28da68de&scoped=true&ts=true"
import script from "./InfoTooltip.vue?vue&type=script&lang=ts"
export * from "./InfoTooltip.vue?vue&type=script&lang=ts"

import "./InfoTooltip.vue?vue&type=style&index=0&id=28da68de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28da68de"]])

export default __exports__